
<template>
      <el-container class="boxWidth">
          <HeaderBar v-if="showHeader" :style="exhiHeaderStyle" :class="{ isExhiHome }"/>
          <el-main :class="{ noPadding, noBottomPadding, greyBackground, isoverflow: $route.meta.overvisable }">
              <ash-breadcrumb :is-show="isShowBreadcrumb" :data="BreadcrumbData"/>
              <router-view/>
          </el-main>
          <el-footer class="footerBox" style="height:40px"><FooterBar/></el-footer>
      </el-container>
</template>

<script>
import {defineAsyncComponent} from 'vue';
import { mapState } from 'vuex'
const HeaderBar = defineAsyncComponent(() => import('./Header'))
const FooterBar = defineAsyncComponent(() => import('./Footer'))
const AshBreadcrumb = defineAsyncComponent(() => import('./Breadcrumb'))
export default {
    components: { FooterBar, HeaderBar, AshBreadcrumb },
    data() {
        return { show: true, noDataImg: require('@/assets/images/no-img.jpg') };
    },
    computed: {
        ...mapState({ exhiConfigInfo: state => state.common.exhiConfig }),
        isExhiHome() {
            return this.$route.meta && this.$route.meta.exhiHome
        },
        exhiHeaderStyle() {
            if (this.isExhiHome && this.exhiConfigInfo) {
                return {
                    backgroundImage: `url(${this.$imageFunctoin(this.exhiConfigInfo.bigPhotoUrl) || this.noDataImg})`,
                    height: '500px',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center center',
                    backgroundSize: 'cover',
                    marginTop: '60px'
                };
            }
            return {}
        },

        /** 是否显示头部 */
        showHeader() { return !this.$route.meta.w3Approve },

        /** main不需要padding */
        noPadding({ $route }) { return $route.meta.noPadding },
        noBottomPadding({ $route }) { return $route.name === 'mediaPortal' },
        greyBackground({ $route }) { return $route.meta.greyBack },
        ...mapState({ activeIndex: state => state.common.activeIndex, isShowBreadcrumb: state => state.common.isShowBreadcrumb, BreadcrumbData: state => state.common.BreadcrumbData, imgurl: state => state.common.imgurl })
    }
}
</script>

<style lang="less" scoped>
.boxWidth {
    height: 100vh;
}
.header {     height: 1px; } .el-footer {     background-color: #222222;     color: #333;     text-align: center;     line-height: 26px; } .el-main {
    margin-bottom: 40px;  background-color: #fff;     color: #333;     overflow: auto; } .isoverflow {     overflow: visible; } .noPadding{     padding:0px 0px 20px 0px; } .noBottomPadding{     padding: 0; } .greyBackground {     background-color: #fafafa !important;     padding: 0 !important; } body > .el-container {     margin-bottom: 40px; } .footerBox {     position: relative;     height: 38px;     line-height: 38px; z-index: 9;
    position: fixed;
    bottom: 0;
    width: 100%;
    margin-top: 40px;
}
</style>
